import { create } from "zustand";
import { INiche, INicheMap } from "@/common/services/types";

interface INichesState {
  niches: INicheMap;
  updateNiches: (incomingNiches: INiche[]) => void;
  getNiche: (id: string) => INiche | undefined;
}

export const useNichesStore = create<INichesState>(
  (set, get) => ({
    niches: {},
    updateNiches: (incomingNiches: INiche[]) => set((state) => {
      const updatedNiches = { ...state.niches };

      incomingNiches.forEach((niche: INiche) => {
        updatedNiches[niche.id] = {
          ...(updatedNiches[niche.id] ?? {}),
          ...niche,
        };
      });

      return { niches: updatedNiches };
    }),
    getNiche: (id: string) => {
      const { niches } = get();
      return niches[id];
    }
  }),
);
